export default __webpack_public_path__ + "static/RoeDeer-db63b91aee6591fbf050d665e8ff8777.jpeg";